'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ArrowRight, Home } from 'lucide-react';
import Nav from '@/components/Nav/Nav';
import Section from '@/components/Section';
import QuestionMarkParallax from '@/components/QuestionMarkParallax';
import { getDictionary, localePath, locales, defaultLocale, Locale } from '@/lib/i18n';

// Static export: not-found.tsx gets no params, so the locale comes from the URL.
export default function NotFoundContent() {
  const first = usePathname().split('/')[1];
  const lang = locales.includes(first as Locale) ? (first as Locale) : defaultLocale;
  const t = getDictionary(lang);

  return (
    <>
      <Nav locale={lang} />
      <main>
        <Section className='relative flex min-h-[calc(100dvh-80px)] flex-col items-center justify-center text-center'>
          <QuestionMarkParallax size='h-[500px] md:h-[700px]' />
          <h1 className='text-8xl leading-none font-bold uppercase md:text-[10rem]'>
            {t.notFound.title}
          </h1>
          <p className='mt-[20px] text-xl'>{t.notFound.body}</p>
          <Link
            href={localePath(lang, '/')}
            className='mt-[40px] inline-flex w-fit items-center gap-[12px] rounded-[8px] border border-fg px-[24px] py-[14px] text-xl font-bold text-fg no-underline hover:bg-fg hover:text-bg'
          >
            <Home size={20} />
            {t.nav.home}
            <ArrowRight size={20} />
          </Link>
        </Section>
      </main>
    </>
  );
}
